module.exports = __webpack_public_path__ + "342fa8b2757cf6cb143f4c4770cae10e.jpg";